var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-336-560h1624v702H-336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232F3E",
    d: "M3.278 12.623a.932.932 0 010-1.327l1.344-1.328a.959.959 0 011.343 0l4.16 4.11 8.91-8.803a.957.957 0 011.343 0l1.344 1.327c.37.367.37.961 0 1.328L10.797 18.725a.958.958 0 01-1.344 0l-6.175-6.102z"
  }))));
}

export default SvgCheck;